<form>
  <div class="full-width-container">
    <p> Wstaw na szablonie strony głównej placeholder <code>%HOME_PAGEWIDGET%</code> aby wstrzyknąć kod poniższego widgeta</p>
    <mat-form-field>
      <textarea matInput placeholder="Kod HTML dla widgetu na stronie głównej" [(ngModel)]="domain.homePageWidget" name="homePageWidget" rows="20"></textarea>
    </mat-form-field>
  </div>
</form>
